import { styled, Typography } from "@mui/material"
import type React from "react"
import { extraColors } from "../../utils/theme"

export const Tag = styled("div")({
  backgroundColor: extraColors.dark10,
  padding: "1px 6px",
  borderRadius: 2,
  border: `1px solid ${extraColors.hint}`,
  display: "flex",
  alignItems: "center",
  textWrap: "nowrap",
  width: "fit-content",
  color: extraColors.white,
})

export const GenericTag: React.FC<{
  text: string
  className?: string
}> = ({ text, className }) => {
  return (
    <Tag className={className}>
      <Typography variant="tiny">{text}</Typography>
    </Tag>
  )
}
